import { useEffect, useState } from 'react'
import UpdatePricingForm from './updatePricingForm'
import { useNavigate, useParams } from 'react-router-dom'
import { getPricingDetails } from 'utils/api/pricingApi'
import {
  ERROR_CODES,
  PAGE_NOT_FOUND,
  PRICING_FORM_FIELDS,
} from 'utils/constants'
import { getOnlyDate } from 'utils/helpers'
import { Spinner } from 'components/common'
import BackButton from 'components/backButton'
import { AxiosError } from 'axios'

const {
  PROMO_END_DATE,
  PROMO_START_DATE,
  SPECIAL_PRICE_START_DATE,
  SPECIAL_PRICE_END_DATE,
  SLASH_PRICE_END_DATE,
  SLASH_PRICE_START_DATE,
} = PRICING_FORM_FIELDS

const UpdatePricingContainer = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<Record<string, any> | null>(null)
  const navigate = useNavigate()

  const { id } = useParams()

  // To fetch price based on pricing id
  const getPricingData = async (id: string) => {
    try {
      setLoading(true)
      const { data } = await getPricingDetails(id)
      // Flat obj to be used in hook form
      const flatObj = {
        ...data,
        ...data.store,
        ...data.catalogue,
        storeId: data?.store?._id,
        barcode: data?.catalogue?._id,
        aggregator: data?.aggregator?._id,
      }

      // Will remove the time string from the following dates
      flatObj[PROMO_START_DATE.key] = getOnlyDate(flatObj[PROMO_START_DATE.key])
      flatObj[PROMO_END_DATE.key] = getOnlyDate(flatObj[PROMO_END_DATE.key])
      flatObj[SPECIAL_PRICE_START_DATE.key] = getOnlyDate(
        flatObj[SPECIAL_PRICE_START_DATE.key],
      )
      flatObj[SPECIAL_PRICE_END_DATE.key] = getOnlyDate(
        flatObj[SPECIAL_PRICE_END_DATE.key],
      )
      flatObj[SLASH_PRICE_START_DATE.key] = getOnlyDate(
        flatObj[SLASH_PRICE_START_DATE.key],
      )
      flatObj[SLASH_PRICE_END_DATE.key] = getOnlyDate(
        flatObj[SLASH_PRICE_END_DATE.key],
      )
      setData(flatObj)
      setLoading(false)
    } catch (error) {
      if (error instanceof AxiosError) {
        const msg = error?.response?.data?.errors?.msg
        if (msg === ERROR_CODES.NOT_FOUND) {
          return navigate(PAGE_NOT_FOUND.path)
        }
      }
    }
  }

  useEffect(() => {
    if (id) {
      getPricingData(id)
    }
  }, [])

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <BackButton />
      <p className="font-bold">{data?.description || 'Item Name'}</p>
      <div className="mt-4 rounded-lg border bg-white p-5">
        <div className=" mx-auto max-w-[900px]">
          {data && id && (
            <UpdatePricingForm pricingData={data} pricingId={id} />
          )}
        </div>
      </div>
    </>
  )
}

export default UpdatePricingContainer
